import axios from 'axios';
import apiConfig from '../../api.config';

export default function getHotelBillingConfiguration() {
  const {
    host,
    URIs: { getHotelBillingConfiguration },
  } = apiConfig;

  const uri = `${host}${getHotelBillingConfiguration}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
